<template>
  <div class="newmessage-wrap phrase">
    <div class="list-create">
      <div class="newmessage-title phrase">
        テンプレート選択
        <div class="flex-space"></div>
        <div class="newmessage-button" @click="closePhraseSelect()">
          <font-awesome-icon :icon="['fal', 'times']" />
        </div>
      </div>

      <div class="flex-row" style="height:40px;">
        <div class="header-search-wrap phrase">
          <font-awesome-icon :icon="['fas', 'search']" style="font-size: 16px; color: #aaa; margin-right: 10px" />
          <el-input class="head-search clearable" placeholder="検索" clearable v-model="sort_keyword" @input="loadPhrase()"></el-input>
        </div>
        <div class="flex-space"></div>
        <div class="phrase-brand-member-select-wrap" v-if="activate == 11 || activate > 12">
          <memberBrandSelect style="padding:0 10px" :referer="'newmessage'" :type="'client'" :target_client="target_client" @selectClient="selectClient" />
          <memberBrandSelect style="padding:0 10px" :referer="'newmessage'" :type="'member'" :member="member" @selectMember="selectMember" />
        </div>
      </div>
      <div class="inbox-phrase-select-wrap">
        <div class="flex-row" style="height:40px" v-loading="loading" v-if="loading"></div>
        <div v-else-if="phrase_num > 0" class="inbox-phrase-select" @click="insertTemplete(phrase.phrase_html), selectPhrase(phrase.phrase_content)" v-for="phrase in phrase_list" :key="phrase.id">
          <div class="inbox-phrase-select-title">{{ phrase.phrase_title }}</div>
          <div class="inbox-phrase-select-content">{{ phrase.phrase_content }}</div>
        </div>
        <div v-else>
          <div class="inbox-phrase-select-content nophrase"><span v-if="is_sort">該当する</span>テンプレートがありません</div>
        </div>
      </div>
      <div class="inbox-phrase-select-bottom">
        <!-- <div class="inbox-phrase-select-bottom-button">テンプレートを編集・新規作成</div> -->
        <el-button size="mini" @click.exact="toPhraseSetting()" @click.ctrl.exact="toPhraseSettingNewWindow()" @click.meta.exact="toPhraseSettingNewWindow()"
          >テンプレート編集・作成画面へ
          <font-awesome-icon :icon="['far', 'external-link']" style="margin-left: 5px;" />
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
const root = process.env.VUE_APP_API;
const loadPhraseAPI = root + "/api/message/load_phrase";
const loadMemberAPI = root + "/api/member/load_member";
import memberBrandSelect from "../list/list_select_member";
import { handleApiResponse, ERROR_MESSAGES } from "@/components/common/responseHelper";

export default {
  name: "phraseSelect",
  components: {
    memberBrandSelect,
  },
  props: ["phrase_select_drawer"],
  data() {
    return {
      sort_keyword: "",
      phrase_list: [],
      phrase_num: -1,
      member: [],
      target_client: [],
      loading: false,
      requestId: 0,
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    activate() {
      return this.$store.state.activate;
    },
    client_select() {
      return this.$store.state.client_select;
    },
    member_select() {
      return this.$store.state.member_select;
    },
    is_sort() {
      if (this.member_select.person_id != "all" || this.client_select.target_client_id != "all" || this.sort_keyword != "") {
        return true;
      } else {
        return false;
      }
    },
    sort_key() {
      return this.$store.state.phrase_sort_key;
    },
    sort_order() {
      return this.$store.state.phrase_sort_order;
    },
  },
  mounted() {
    this.loadPhrase();
    this.loadMember();
  },
  methods: {
    loadPhrase() {
      this.loading = true;
      this.axios.cancel(this.requestId);
      this.requestId += 1;
      this.axios
        .get(loadPhraseAPI, {
          requestId: this.requestId,
          params: {
            token: this.token,
            user_token: this.user_token,
            sort_key: this.sort_key,
            sort_order: this.sort_order,
            person_id: this.member_select.person_id,
            target_client_id: this.client_select.target_client_id,
            sort_keyword: this.sort_keyword,
          },
        })
        .then((response) => {
          this.phrase_list = response.data.phrase_list;
          this.phrase_num = response.data.phrase_num;
          setTimeout(() => {
            this.loading = false;
          }, 300);
        });
    },
    loadMember() {
      this.axios
        .get(loadMemberAPI, {
          params: {
            token: this.token,
          },
        })
        .then((response) => {
          if (handleApiResponse(response)) {
            console.error(ERROR_MESSAGES.DATA_FETCH_ERROR);
            return;
          }
          this.member = response.data.member;
          this.target_client = response.data.target_client;
        });
    },
    selectMember(member) {
      this.$store.dispatch("selectMember", member);
      this.phrase_list = [];
      this.loadPhrase(true);
    },
    selectClient(client) {
      this.$store.dispatch("selectClient", client);
      this.phrase_list = [];
      this.loadPhrase(true);
    },
    insertTemplete(phrase_html) {
      this.$emit("insertTemplete", phrase_html);
    },
    selectPhrase(phrase_content) {
      this.$emit("selectPhrase", phrase_content);
    },
    closePhraseSelect() {
      this.$emit("update:phrase_select_drawer", false);
    },
    toPhraseSetting() {
      this.$router.push({
        name: "message",
        query: {
          activeName: "phrase",
        },
      });
    },
    toPhraseSettingNewWindow() {
      let routeData = this.$router.resolve({
        name: "message",
        query: {
          activeName: "phrase",
        },
      });
      window.open(routeData.href, "_blank");
    },
  },
  filters: {},
  watch: {},
};
</script>
